import 'reflect-metadata';
import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import { resolveGalaxyAccess } from '@core/pages/oj/galaxy/components/home/galaxy-home.helpers';
import { UserService } from '@core/services/user.service';

/**
 * 银河争霸赛比赛页面访问守卫
 *
 * 规则：未登录 → 重定向登录页（携带 redirect 回银河，登录成功后回跳再由本守卫二次校验履约资格）；
 * 已登录但非履约 且 非老师 → 重定向 OJ 首页('/')，不弹登录弹窗。
 * 履约字段来源：userService.user.exerciseId 不为空；
 * 老师字段来源：userService.user.accountId 有值（老师/家长等查看学生数据的账号）。
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) {
    const userService = useRootService(UserService);
    const isLogin = userService.isLogin();
    const isFulfillmentUser = userService.user.exerciseId != null;
    // accountId 有值即老师身份（学生账号该字段为空/0）
    const isTeacher = (userService.user.accountId ?? 0) > 0;
    const action = resolveGalaxyAccess({
      isLogin,
      isFulfillmentUser,
      isTeacher,
    });
    if (action?.type === 'login') {
      // 未登录 → 登录页，登录成功后回跳银河（再由本守卫二次校验履约资格）
      return navigateTo({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
    if (action?.type === 'home') {
      return navigateTo('/');
    }
  }
});
